import { render, staticRenderFns } from "./EmailsOverview.vue?vue&type=template&id=1138d256&scoped=true"
import script from "./EmailsOverview.vue?vue&type=script&lang=js"
export * from "./EmailsOverview.vue?vue&type=script&lang=js"
import style0 from "./EmailsOverview.vue?vue&type=style&index=0&id=1138d256&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1138d256",
  null
  
)

export default component.exports